import { getDocs, limit, query, QueryCompositeFilterConstraint, QueryOrderByConstraint } from 'firebase/firestore/lite';

import { DBDocObject } from '../../../../common/src/legacy/objects/generic/db-doc/db-doc-object';
import { addDocToCache } from './cache/add-doc-to-cache';
import { getCollectionRef, GetCollectionRefInput } from './get-collection-ref';

export interface GetDocsArrayInput<T> extends GetCollectionRefInput {
  constraints?: QueryCompositeFilterConstraint;
  orderBy?: QueryOrderByConstraint;
  filter?: (doc: T) => boolean;
  limit?: number;
}

export const getDocsArray = async <T>(input: GetDocsArrayInput<T>) => {
  console.log('getDocsArray: Starting', input);
  const { Deserializer, constraints, orderBy, filter } = input;
  const collectionRef = await getCollectionRef({ Deserializer });
  let docsQuery = query(collectionRef);
  const filterFn = filter ?? ((_: T) => true);
  if (constraints) {
    docsQuery = query(collectionRef, constraints);
  }
  if (orderBy) {
    docsQuery = query(docsQuery, orderBy);
  }
  if (input.limit) {
    docsQuery = query(docsQuery, limit(input.limit));
  }
  const rawResult = await getDocs(docsQuery);

  if (rawResult.empty) {
    console.log('getDocsArray: No docs found');
    return [];
  }

  const unfilteredDocs = rawResult.docs.map((doc) => doc.data()) as T[];
  void Promise.all(unfilteredDocs.map((doc) => addDocToCache({ doc: doc as unknown as DBDocObject, Deserializer })));
  const result = unfilteredDocs.filter(filterFn);
  console.log('getDocsArray: Completed', input);
  return result;
};
